// extracted by mini-css-extract-plugin
export default {"icon":"ModeSwitch_icon__i1eGo","title":"ModeSwitch_title__O5lpN","container":"ModeSwitch_container__37REi","btn":"ModeSwitch_btn__odw1f","btnActive":"ModeSwitch_btnActive__T7odv"};